import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = ["href"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = { class: "header-link-copy" };
import Strings from "src/shared/Strings";
import { useAreRewardSupplierDisplayTypesContainShopify, useRewardSupplierDisplayTypes, } from "src/shared/store/reward/supplier/composables";
import { chain, contains, pluck } from "underscore";
import { computed, ref, toRef, watch } from "vue";
import SecondaryNavigationItem from "./SecondaryNavigationItem.vue";
import { usePrograms } from "src/resources/programs";
import { useArrayMap } from "@vueuse/core";
import Tooltip from "src/shared/v-components/ui/Tooltip.vue";
import { useExtoleNavbarToggle, useSecondaryMenuParent } from "../composables";
import { useNavigationContext } from "../navigationContext";
import featureFlagService from "src/shared/store/feature-flag/feature-flag-service";
import { useRewardBanks } from "../composables";
const REWARDS_MENU = "rewards";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MainNavigationItem',
    props: {
        hasClientSelector: { type: Boolean },
        isUserSupportUser: { type: Boolean },
        isSelfServiceUser: { type: Boolean },
        item: {},
        isExpanded: { type: Boolean },
        currentPage: {}
    },
    emits: ["toggledNav"],
    setup(__props, { emit: __emit }) {
        const PROGRAMS_MENU = ["programs", "performance"];
        const MAP = {
            TANGO_V2: "Gift Cards",
            CUSTOM_REWARD: "Custom Rewards",
            MANUAL_COUPON: "Coupons",
            SALESFORCE_COUPON: "SFCC Coupons",
        };
        const props = __props;
        const emit = __emit;
        const { secondaryMenuParent } = useSecondaryMenuParent();
        const navigationContext = useNavigationContext();
        const { isNavbarCollapsed } = useExtoleNavbarToggle();
        const isCurrentItemExpanded = ref(false);
        const { data: programs } = usePrograms({
            include_archived: false,
        });
        const { displayTypes, primer: displayTypesPrimer } = useRewardSupplierDisplayTypes();
        const { areRewardSupplierDisplayTypesContainShopify } = useAreRewardSupplierDisplayTypesContainShopify();
        const { rewardBanks } = useRewardBanks();
        const rewardBankMenuItems = computed(() => {
            return rewardBanks.value.filter(Boolean).map((rewardBank) => {
                if (rewardBank) {
                    return {
                        text: rewardBank.name,
                        link: `/integrations#/extensions/${rewardBank.id}`,
                    };
                }
            });
        });
        const isActive = computed(() => {
            const [fullPath] = props.currentPage.split("#");
            const path = new URL(fullPath, window.location.origin).pathname;
            const parts = path.split("/").filter(Boolean);
            const isExternalPage = ["/settings", "/notifications", "/invite"].includes(path);
            if (isExternalPage) {
                return false;
            }
            return (props.item.link === props.currentPage.replace(/#\//, "") ||
                props.item.link === parts[0] ||
                props.item.name === secondaryMenuParent.value);
        });
        const isItemExpanded = computed(() => {
            if (props.isExpanded === false) {
                return false;
            }
            return isCurrentItemExpanded.value || props.isExpanded || isActive.value;
        });
        const isShopify = (rewardSupplierDisplayType) => {
            return (rewardSupplierDisplayType || "").toLowerCase().includes("shopify");
        };
        const programMenuItems = computed(() => {
            const programItems = useArrayMap(programs.value || [], (program) => {
                return {
                    text: program.name,
                    link: `/program/#/${program.program_label}`,
                };
            }).value;
            return [...props.item.secondaryNav, ...programItems];
        });
        const rewardSupplierMenuItems = computed(() => {
            const integrationRewardSuppliers = chain(displayTypes.value)
                .filter((rewardSupplierDisplayType) => {
                if (areRewardSupplierDisplayTypesContainShopify.value &&
                    featureFlagService.isOn("ENFORCE_SHOPIFY_RESTRICTIONS")) {
                    return isShopify(rewardSupplierDisplayType);
                }
                return (!rewardSupplierDisplayType
                    .toLowerCase()
                    .includes("collectible") &&
                    !rewardSupplierDisplayType.toLowerCase().includes("bankable"));
            })
                .map((rewardSupplierDisplayType) => ({
                text: Strings.capitalize(rewardSupplierDisplayType),
                link: `/account-rewards/${Strings.encodeLabel(rewardSupplierDisplayType)}`,
                label: MAP[rewardSupplierDisplayType] || rewardSupplierDisplayType,
            }))
                .filter((rewardSupplierDisplayType) => {
                return !contains(pluck(props.item.secondaryNav, "text"), rewardSupplierDisplayType.label);
            })
                .value();
            return areRewardSupplierDisplayTypesContainShopify.value &&
                featureFlagService.isOn("ENFORCE_SHOPIFY_RESTRICTIONS")
                ? [
                    {
                        link: "/account-rewards",
                        text: "Rewards",
                    },
                    ...integrationRewardSuppliers,
                ]
                : [
                    ...props.item.secondaryNav,
                    ...integrationRewardSuppliers,
                    ...rewardBankMenuItems.value,
                ];
        });
        const computedMenuItems = computed(() => {
            if (contains(PROGRAMS_MENU, props.item.name)) {
                return programMenuItems.value;
            }
            else if (props.item.name === REWARDS_MENU) {
                return rewardSupplierMenuItems.value;
            }
            else {
                return props.item.secondaryNav;
            }
        });
        const toggleSecondaryNav = () => {
            isCurrentItemExpanded.value = !isCurrentItemExpanded.value;
            emit("toggledNav", props.item.name);
        };
        watch(toRef(isNavbarCollapsed), (value) => {
            isCurrentItemExpanded.value = false;
            emit("toggledNav", props.item.name);
        });
        const handleClick = () => {
            // Record the navigation context
            navigationContext.recordNavigation({
                from: secondaryMenuParent.value,
                to: props.item.link,
                menuItem: props.item.name,
            });
            secondaryMenuParent.value = props.item.name;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("li", {
                id: `${_ctx.item.name}-menu-item`
            }, [
                _createElementVNode("a", {
                    class: _normalizeClass(["button", {
                            active: isActive.value,
                            'has-secondary-menu': _ctx.item.hasSecondaryNav,
                        }]),
                    href: _ctx.item.link,
                    onClick: handleClick
                }, [
                    _createVNode(Tooltip, {
                        message: _unref(Strings).capitalize(_ctx.item.name)
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", {
                                class: "left-nav-icon",
                                innerHTML: _ctx.item.icon
                            }, null, 8 /* PROPS */, _hoisted_3)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["message"]),
                    _createElementVNode("span", {
                        class: "left-nav-icon",
                        innerHTML: _ctx.item.icon
                    }, null, 8 /* PROPS */, _hoisted_4),
                    _createElementVNode("span", _hoisted_5, [
                        _createTextVNode(_toDisplayString(_unref(Strings).capitalize(_ctx.item.name)) + " ", 1 /* TEXT */),
                        (_ctx.item.hasSecondaryNav &&
                            !(_ctx.isUserSupportUser || _ctx.isSelfServiceUser))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "header-link-caret js-toggle-secondary-nav",
                                onClick: _withModifiers(toggleSecondaryNav, ["prevent", "stop"])
                            }, [
                                _createElementVNode("i", {
                                    class: _normalizeClass(["fa", {
                                            'fa-chevron-down': isItemExpanded.value,
                                            'fa-chevron-right': !isItemExpanded.value,
                                        }])
                                }, null, 2 /* CLASS */)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ], 10 /* CLASS, PROPS */, _hoisted_2),
                (_ctx.item.hasSecondaryNav)
                    ? _withDirectives((_openBlock(), _createBlock(SecondaryNavigationItem, {
                        key: 0,
                        "menu-items": computedMenuItems.value,
                        "current-page": _ctx.currentPage,
                        "parent-name": _ctx.item.name
                    }, null, 8 /* PROPS */, ["menu-items", "current-page", "parent-name"])), [
                        [_vShow, !_unref(isNavbarCollapsed) && isItemExpanded.value]
                    ])
                    : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
